import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20warm%20elegant%20abstract%20artistic%20composition%20with%20soft%20coral%20and%20golden%20tones%2C%20flowing%20organic%20gradient%20shapes%2C%20modern%20minimal%20media%20platform%20atmosphere%2C%20sophisticated%20editorial%20design%20aesthetic%20with%20subtle%20texture%20layers%2C%20harmonious%20warm%20neutral%20background%20with%20gentle%20light%20diffusion%2C%20professional%20creative%20studio%20vibe&width=1600&height=900&seq=hero-bg-2024&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 max-w-3xl leading-tight">
          专注优质内容创作与传播
        </h1>
        <p className="text-sm md:text-base text-background-50/85 max-w-xl mb-8 leading-relaxed">
          汇聚海量精品资源，探索蜜桃传媒官方频道，发现最新内容更新、独家资源与会员专属服务
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/latest"
            className="whitespace-nowrap px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
          >
            探索最新内容
          </Link>
          <Link
            to="/about"
            className="whitespace-nowrap px-6 py-3 rounded-md bg-background-50/15 text-background-50 text-sm font-medium border border-background-50/30 hover:bg-background-50/25 transition-colors duration-200 cursor-pointer backdrop-blur-sm"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}